import Music from './Music'
import homeIndex from './homeIndex'
let routesArray = []

let toArray = (pages) => {
  Object.keys(pages).forEach((key) => {
    let obj = pages[key]
    Object.keys(obj).forEach((key) => {
      routesArray.push(obj[key])
    })
  })
}

toArray([Music, homeIndex])

export default routesArray



// WEBPACK FOOTER //
// ./src/router/module/index.js